import axios from 'axios'
const baseURL = '/back-office'
export default class ApiManagerBoCutomer {
    static updateustomers(params) {
        return axios
            .put(`${baseURL}/v2/customer/update`, params)
            .then((res) => {
                return res.data
            })
            .catch((error) => {
                console.error('Error fetching customers:', error)
                throw error
            })
    }

    static updateCatgorie(params) {
        return axios
            .put(`${baseURL}/v2/customer/category/update`, params)
            .then((res) => {
                return res.data
            })
            .catch((error) => {
                console.error('Error fetching customers:', error)
                throw error
            })
    }

    static updateAlert(params) {
        return axios
            .put(`${baseURL}/v2/customer/alert/update`, params)
            .then((res) => {
                return res.data
            })
            .catch((error) => {
                console.error('Error fetching customers:', error)
                throw error
            })
    }
}
